import React from "react";
import { ArrowRight, MousePointer2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
export default function TheLoneExplorersView() {
  const services = [];
  return <section data-section-id="2858" id="the-moondos-vision" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground flex flex-col">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.03] pointer-events-none select-none overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-full border-l border-t border-primary/20" />
        <span className="absolute -bottom-20 -right-20 text-[400px] font-bold leading-none tracking-tighter text-primary">
          MD
        </span>
      </div>

      {}
      <header className="relative z-20 flex items-center justify-between px-6 py-8 md:px-12 lg:px-20">
        <Link to="/">
          <WvcLogo className="h-8 w-auto" />
        </Link>
        <div className="hidden md:flex items-center gap-8">
          {services.map((service, i) => <span key={service.id} data-index={i} className="text-[10px] uppercase tracking-widest font-mono text-muted-foreground">
              {service.name}
            </span>)}
        </div>
      </header>

      {}
      <div className="relative z-10 flex-1 flex flex-col justify-center px-6 md:px-12 lg:px-20 pb-20">
        <div className="max-w-6xl w-full">
          

          <h1 className="text-5xl md:text-7xl lg:text-9xl font-bold tracking-tighter leading-[0.9] mb-8 max-w-4xl">WE BUILD <br /><br /></h1>

          <p className="max-w-xl text-lg md:text-xl font-mono mb-12 leading-relaxed text-muted-foreground">Brands.&nbsp;<span style={{
            color: 'rgb(0, 0, 0)',
            letterSpacing: '-0.32px'
          }}>Websites.&nbsp;</span><span style={{
            color: 'rgb(0, 0, 0)',
            letterSpacing: '-0.32px'
          }}>Content.&nbsp;</span><span style={{
            color: 'rgb(0, 0, 0)',
            letterSpacing: '-0.32px'
          }}>Online Presence.</span></p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link to="/WorkPage" className="w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-bold rounded-md bg-primary text-primary-foreground shadow-xs hover:bg-primary/90 uppercase tracking-widest transition-all">service</Button>
            </Link>
            <Link to="/StartYourProjectPage" className="w-full sm:w-auto">
              <Button variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base font-bold uppercase tracking-widest border-primary rounded-md hover:bg-primary hover:text-background transition-all">
                Start a Project
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {}
      <div className="relative z-10 grid grid-cols-1 md:grid-cols-3 border-t border-primary/10">
        
        
        <div className="relative h-48 md:h-auto overflow-hidden">
          
          
        </div>
      </div>

      {}
      <div className="absolute bottom-10 right-10 z-20 hidden lg:flex flex-col items-center gap-4">
        
        <div className="h-24 w-px bg-primary/10 relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1/2 bg-primary animate-[scrollLine_2s_infinite]" />
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
        .animate-fade-in {
          animation: fadeIn 1s ease-out forwards;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>;
}